import React from 'react';
import { PageHeader } from '@components/Shared/PageHeader';
import { DocExtractContainer } from '@containers/DocExtractContainer';
import { PageContainer } from './DocExtract.styles';

export default function DocExtract() {
  return (
    <PageContainer>
      <PageHeader 
        title="Document Extraction" 
        description="Extract key information from your documents."
      />
      <DocExtractContainer />
    </PageContainer>
  );
};